import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { SPORT_TYPE_FOOTBALL } from '../../constants/sports';
import getSportType from '../../state/selectors/getSportType';
import FootballGameFilterPane from './FootballGameFilterPane';
import { getQlikAppId } from '../../state/selectors/getQlikAppId';

class GameFilterPane extends PureComponent {
  render() {
    const { sport, qlikAppId } = this.props;

    if (!qlikAppId) {
      return null;
    }

    switch (sport) {
      case SPORT_TYPE_FOOTBALL:
        return <FootballGameFilterPane />;
      default:
        return null;
    }
  }
}

GameFilterPane.propTypes = {
  qlikAppId: PropTypes.string.isRequired, // supplied from Redux
  sport: PropTypes.string.isRequired, // supplied from Redux
};

const mapStateToProps = state => ({
  qlikAppId: getQlikAppId(state),
  sport: getSportType(state),
});

export default connect(mapStateToProps)(GameFilterPane);
